import PropTypes from 'prop-types';
import React from 'react';
import RefundAccoundAndCardInfo from './refund-account-and-card-info';
import RefundBreakdown from './refund-breakdown';
import RefundPenaltyCharge from './refund-penalty-charge';
import RefundRouteReview from './refundRouteReview';
import TranslatedCopy from '../../../intl/translated-copy';
import cx from 'classnames';
import useWizard from '../wizard/useWizard';
import { connect } from 'react-redux';
import { formatAmountWithDecimals } from '../../../../cms-wrapper/utils';
import { withWindow } from '../../../decorators/window';

const RefundReview = ({
  breakpointNewDesign,
  dispatch,
  optionSelected,
  quoteRefundData,
  stateStoreFront,
}) => {
  const breakdownClass = cx({
    'RefundReview-secondContainer-breakdownAndWarnings-breakdown': true,
    'RefundReview-bottomBorderRadiusNone': nonRefundableExtrasExist,
  });

  const breakdownClassTablet = cx({
    'RefundReview-tablet': true,
    'RefundReview-tablet-bottomBorderRadiusNone': nonRefundableExtrasExist,
  });

  const {
    quotationsToRender,
    nonRefundableExtrasExist,
  } = useWizard();

  const isSmall = breakpointNewDesign === 'small';
  const isMediumOrMediumHigh = (breakpointNewDesign === 'medium' || breakpointNewDesign === 'medium-high');
  const isLarge = breakpointNewDesign === 'large';

  const passengerName = `${quotationsToRender?.[0]?.passenger?.name.split('/')[0]} / ${quotationsToRender?.[0]?.passenger?.name.split('/')[1]}`;
  const total = (quotationsToRender || []).reduce((sum, quotation) => {
    return sum + quotation?.quoteItemAmount?.dAmount;
  }, 0);
  const currencyOfRefund = quotationsToRender?.[0]?.quoteItemAmount?.currencyCode;
  const numberOfDecimalsBE = stateStoreFront?.numberOfDecimalsBE != null ? stateStoreFront.numberOfDecimalsBE : 0;

  const cardNumbers = [];
  (quoteRefundData?.fops || []).forEach(item => {
    if (!cardNumbers.includes(item.fop) && cardNumbers.length < 2) {
      cardNumbers.push(item.fop);
    }
  });

  // Se hizo maquetado, actualmente no existe informacion real para asignar esto
  const showPoints = false;

  return (
    <div className='RefundReview'>
      <div className='RefundReview-container'>
        <TranslatedCopy
          className='RefundReview-container--title'
          copyID='MYB_REFUND_CONFIRMATION'
          tagName='h2'
        />
        { optionSelected === 'AW' &&
          <TranslatedCopy
            className='RefundReview-container--title'
            copyID='MYB_AERO_ACTIVATED_PROPERLY'
            tagName='div'
          />
        }
        { optionSelected === 'Card' &&
          <TranslatedCopy
            className='RefundReview-container--description'
            copyID='MYB_REVIEW_THE_AMOUNT_AND_ACCEPT'
            tagName='p'
          />
        }
        <div className='RefundReview-secondContainer'>
          { (isSmall || isLarge) &&
            <RefundAccoundAndCardInfo
              cardNumbers={ cardNumbers }
              currencyOfRefund={ currencyOfRefund }
              numberOfDecimalsBE={ numberOfDecimalsBE }
              total={ total }
            />
          }
          <div className='RefundReview-secondContainer-breakdownAndWarnings'>
            { isSmall &&
              <div className={ breakdownClass }>
                <TranslatedCopy
                  className='RefundReview-secondContainer-breakdownAndWarnings-breakdown--header'
                  copyID='MYB_YOUR_REFUND'
                  tagName='p'
                />
                <RefundBreakdown
                  breakpointNewDesign={ breakpointNewDesign }
                  dispatch={ dispatch }
                />
              </div>
            }
            { isMediumOrMediumHigh &&
              <div className={ breakdownClassTablet }>
                <div className='RefundReview-tablet-accountDetails'>
                  <div className='RefundReview-tablet-accountDetails-userAccount'>
                    <TranslatedCopy
                      className='RefundReview-tablet-accountDetails-userAccount--breakdownTitle'
                      copyID='MYB_YOUR_REFUND'
                      tagName='p'
                    />
                    { (optionSelected === 'AW' || showPoints) &&
                      <div className='RefundReview-tablet-accountDetails-userAccount-user'>
                        <TranslatedCopy
                          className='RefundReview-tablet-accountDetails-userAccount-user--paymentOption'
                          tagName='p'
                          copyID='MYB_AERO_ACCOUNT'
                        />
                        <p className='RefundReview-tablet-accountDetails-userAccount-user--userName'>{ passengerName }</p>
                        <div className='RefundReview-tablet-accountDetails-userAccount-user-pointsSection'>
                          { '0 ' }
                          <TranslatedCopy
                            className='RefundReview-tablet-accountDetails-userAccount-user-pointsSection--pointsText'
                            copyID='MYB_POINTS_SELECT'
                            tagName='span'
                          />
                        </div>
                      </div>
                    }
                    { optionSelected === 'Card' &&
                      <div className='RefundReview-tablet-accountDetails-userAccount-user'>
                        <TranslatedCopy
                          className='RefundReview-tablet-accountDetails-userAccount-user--paymentOption'
                          copyID='MYB_BANK_CARD_REFUND'
                          tagName='p'
                        />
                        { cardNumbers.map((cardNumber, index) =>
                          (<p className='RefundReview-tablet-accountDetails-userAccount-user--userName' key={ index }>
                            <TranslatedCopy copyID='MYB_CARD' />{ ` ****${cardNumber}` }
                          </p>)
                        ) }
                        { showPoints &&
                          <div className='RefundReview-tablet-accountDetails-userAccount-user-amountSection'>
                            <span className='RefundReview-tablet-accountDetails-userAccount-user-amountSection--amount'>
                              { `$${ formatAmountWithDecimals(total, numberOfDecimalsBE) }` }
                            </span>
                            { ' ' }
                            <span className='RefundReview-tablet-accountDetails-userAccount-user-amountSection--amount'>{ currencyOfRefund }</span>
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div className='RefundReview-tablet-accountDetails-horizontalLine'></div>
                  <div className='RefundReview-tablet-accountDetails-finalRefund'>
                    <TranslatedCopy
                      copyID='MYB_TOTAL_TO_REFUND'
                      className='RefundReview-tablet-accountDetails-finalRefund--totalHeader'
                    />
                    <div className='RefundReview-tablet-accountDetails-finalRefund-finalRefundDetails'>
                      <p className='RefundReview-tablet-accountDetails-finalRefund-finalRefundDetails--amount'>
                        { showPoints &&
                          <>
                            { '0 ' }
                            <TranslatedCopy
                              tagName='span'
                              copyID='MYB_POINTS_SELECT'
                              className='RefundReview-tablet-accountDetails-finalRefund-finalRefundDetails--currency'
                            />
                            { ' + ' }
                          </>
                        }
                        { `$${ formatAmountWithDecimals(total, numberOfDecimalsBE) }` }
                        <span className='RefundReview-tablet-accountDetails-finalRefund-finalRefundDetails--currency'>{ currencyOfRefund }</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className='RefundReview-tablet-partitionLine' />
                { optionSelected === 'Card' &&
                  <div className='RefundReview-tablet-breakdownWrapper'>
                    <RefundBreakdown
                      dispatch={ dispatch }
                    />
                  </div>
                }
                { optionSelected === 'AW' &&
                  <div className='RefundReview-tablet-reviewRoute'>
                    <RefundRouteReview />
                  </div>
                }
              </div>
            }
            { nonRefundableExtrasExist &&
              <div className='RefundReview-secondContainer-breakdownAndWarnings-extras'>
                <span className='Icon Icon--warningBrandblue RefundReview-secondContainer-breakdownAndWarnings-extras--extrasIcon' />
                <div className='RefundReview-secondContainer-breakdownAndWarnings-extras-textContainer'>
                  <TranslatedCopy
                    copyID='MYB_THERE_ARE_NON_REFUNDABLE_EXTRAS'
                    className='RefundReview-secondContainer-breakdownAndWarnings-extras-textContainer--textExtrasNotRefundable'
                    tagName='p'
                  />
                  <TranslatedCopy
                    copyID='MYB_NEW_TICKET_WILL_BE_GENERATED'
                    className='RefundReview-secondContainer-breakdownAndWarnings-extras-textContainer--textNewTicket'
                    tagName='p'
                  />
                </div>
              </div>
            }
          </div>
        </div>
        { showPoints &&
          <RefundPenaltyCharge />
        }
      </div>
      <div className='RefundReview-breakdown'>
        <RefundBreakdown
          breakpointNewDesign={ breakpointNewDesign }
          dispatch={ dispatch }
        />
      </div>
    </div>
  );
};

RefundReview.propTypes = {
  breakpointNewDesign: PropTypes.string,
  optionSelected: PropTypes.string,
};

const mapStateToProps = (state) => ({
  country: state.LanguageBundle.country,
  language: state.Manage.language,
  quoteRefundData: state?.quoteRefund?.quoteRefundData,
  stateStoreFront: state.Manage.stateStoreFront,
});

const refundReview = connect(mapStateToProps)(RefundReview);

export default withWindow(refundReview);